import Cookies from 'js-cookie';
import axios from 'axios';
import { clearMediaBlobCache } from './media';

const SESSION_KEY = 'zafu_session';

const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

/** Simpan klaim user di sessionStorage (bukan token di JS cookie). */
export const setSessionUser = (user) => {
    if (!user) return;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(user));
};

export const clearSessionUser = () => {
    sessionStorage.removeItem(SESSION_KEY);
};

/**
 * Hydrate session dari response login.
 * Token httpOnly di-set backend; kita hanya simpan klaim untuk UI.
 */
export const hydrateSessionFromLogin = (user, token) => {
    // Hapus cookie token lama yang bisa dibaca JS
    clearAuthCookies();
    const payload = token ? parseJwt(token) : null;
    const session = {
        ...(payload || {}),
        ...user,
        exp: payload?.exp || Math.floor(Date.now() / 1000) + 24 * 60 * 60,
    };
    setSessionUser(session);
    return session;
};

export const isAuth = () => {
    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        if (!raw) return false;
        const user = JSON.parse(raw);
        if (user?.exp && user.exp * 1000 < Date.now()) {
            clearSessionUser();
            return false;
        }
        return user;
    } catch {
        return false;
    }
};

/** Pulihkan session dari cookie httpOnly via /api/auth/me */
export const restoreSession = async () => {
    try {
        const res = await axios.get('api/auth/me', { withCredentials: true });
        if (res.data?.user) {
            setSessionUser(res.data.user);
            return res.data.user;
        }
    } catch {
        clearSessionUser();
    }
    return false;
};

const clearAuthCookies = () => {
    Cookies.remove('token', { path: '/' });
    const domain = process.env.REACT_APP_COOKIE_DOMAIN;
    if (domain) {
        Cookies.remove('token', { path: '/', domain });
    }
};

export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorage = async () => {
    clearSessionUser();
    clearMediaBlobCache();
    localStorage.clear();
    clearAuthCookies();
    try {
        await axios.post('api/auth/logout', {}, { withCredentials: true });
    } catch {
        // ignore
    }
};
